package br.com.heyagenda.domain.util

import kotlin.js.Date
import kotlinx.browser.localStorage

actual object PlatformVisitTracker {
    private const val KEY_PREFIX = "heyagenda_last_visit_"

    actual fun shouldRecordVisit(professionalId: String, windowHours: Long): Boolean {
        if (professionalId.isBlank()) return false
        return try {
            val key = "$KEY_PREFIX$professionalId"
            val now = Date.now().toLong()
            val windowMs = windowHours * 60 * 60 * 1000L

            val stored = localStorage.getItem(key)
            if (stored != null) {
                val lastVisit = stored.toLongOrNull()
                if (lastVisit != null && (now - lastVisit) < windowMs && (now - lastVisit) >= 0) {
                    return false
                }
            }
            localStorage.setItem(key, now.toString())
            true
        } catch (_: Throwable) {
            // Fallback if localStorage is disabled or restricted in private browsing
            true
        }
    }
}
